import { render, staticRenderFns } from "./EditCertificateModal.vue?vue&type=template&id=410aeae0&scoped=true&"
import script from "./EditCertificateModal.vue?vue&type=script&lang=js&"
export * from "./EditCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410aeae0",
  null
  
)

export default component.exports